
import cIcon from "../component/icon.vue";

export default {

	components: {
		cIcon
	},

	data (){
		return {
			showHelp: false
		}
	},

	methods: {
		toggleHelp: function(){
			var el = $(this.$parent.$el).find(".c-help"),
				height;

			if(! el.length) return;


			// open
			if(! this.showHelp){
				el.css("height", "")
				.addClass("-ready");

				height = el.height();

				el.removeClass("-ready");
				el.height(0);
				el.addClass("-open");
				el.height(height);

				this.showHelp = true;
				return;
			}

			// close
			if(this.showHelp){
				el.height(0);
				setTimeout(() => {
					el.removeClass("-open");
					this.showHelp = false;
				}, 300);
				return;
			}
		}
	},

	filters: {
		formatNumber (num){
			return num.toString().split(".")
			.map((value, i) => {
				if(i) return value;
				return value.replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g , "$1,");
			})
			.join(".");
		}
	}

}



// WEBPACK FOOTER //
// ./src/js/mixins/common.js